import { ReactNode } from 'react';
import Toast from './Toast';
import { toast, useToastItems } from '../hooks/useToast';
import '../scss/toast.scss';

interface Props {
  children: ReactNode;
}

const ToastProvider = ({ children }: Props) => {
  const items = useToastItems();

  return (
    <>
      {children}
      {items.length > 0 && (
        <div className="toast-container">
          {items.map(item => (
            <Toast key={item.id} toast={item} onDismiss={toast.dismiss} />
          ))}
        </div>
      )}
    </>
  );
};

export default ToastProvider;
